// extracted by mini-css-extract-plugin
export default {"content":"DateCell-module__content__N01Tv","date":"DateCell-module__date__yjqf9","label":"DateCell-module__label__lAmd5"};